import React from "react";
import { Route, Switch } from "react-router-dom";
import Admin from "../../pages/admin/admin";
import Login from "../../pages/login/login";
import Download from "../../pages/download";
import { Redirect } from "react-router-dom";


function RouterRoot() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/admin" />
      </Route>
      <Route path="/admin" component={Admin} />
      <Route path="/Login" component={Login} />
      <Route path="/download/:id?" component={Download} />
    </Switch>
  );
}

export default RouterRoot;
